import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from './datetime'

export function drugStaticPrintBody(data: any) {
  const userName = data?.userName
  const tenantName = data?.tenantName
  const datas = data?.dataList
  const totalData = data?.totalData
  const CKLRSJData = data?.CKLRSJData
  let sjDatas = ''
  let sumZsl = 0
  let sumJjJe = 0
  let sumSjJe = 0
  let sumJxce = 0
  const date = new Date()

  for (let i = 0; i < datas.length; i++) {
    sjDatas +=
      '<div style="font-size: 8px;display:table;width:100%;clear: left;border-right: 1px solid #000;border-left: 1px solid #000;border-bottom: 1px solid #000">' +
      '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width: 22%;display: table-cell;vertical-align: middle;text-align:left;box-sizing: border-box;border-right: 1px solid #000">' +
      '            <div style="width: 100%;text-align:left">' +
      datas[i].name +
      '            </div>' +
      '            <div style="width: 100%;text-align:left">' +
      (datas[i].tenantSupplierName +
        '/' +
        datas[i].packSpec +
        '/' +
        datas[i].accountUnit +
        '/' +
        datas[i].doseCategory) +
      '            </div>' +
      '            </div>' +
      '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:10%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].billingCategory +
      '            </div>' +
      '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].invWholeCount +
      '            </div>' +
      '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].invSplitCount +
      '            </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].wholeCount +
      '           </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].splitCount +
      '           </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      (!CKLRSJData ? '***' : datas[i].wholeCost) +
      '           </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      (!CKLRSJData ? '***' : datas[i].splitCost) +
      '            </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].wholeRetail +
      '            </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
      datas[i].splitRetail +
      '            </div>' +
      '           <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:8%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box">' +
      (!CKLRSJData ? '***' : datas[i].profit) +
      '            </div>' +
      '        </div>'
    sumZsl += Number(datas[i].count)
    sumJjJe += Number(datas[i].unitPriceAllPrice)
    sumSjJe += Number(datas[i].retailPriceAllPrice)
    const jxce: any = Number(datas[i].differencePrice)
    sumJxce += Number(datas[i].differencePrice)
  }
  // const userBean = getUserBean()
  const content =
    '<div style="margin-left: 10px;margin-right: 10px">' +
    '    <h5 style="text-align: center;margin-bottom: 5px;">' +
    tenantName +
    '</h5>' +
    '    <h6 style="text-align: center;margin-top: 5px;margin-bottom: 5px;">药&nbsp;&nbsp;品&nbsp;&nbsp;销&nbsp;&nbsp;售&nbsp;&nbsp;统&nbsp;&nbsp;计</h6>' +
    '    <div style="font-size:8px;display:table;width:100%;align-items:center;clear: left;border: 1px solid #000">' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 22%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '            药品名称' +
    '        </div>' +
    '       <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 10%;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '           开票项目' +
    '       </div>' +
    '        <div style="display: table-cell;vertical-align: middle;width: 15%;border-right: 1px solid #000;box-sizing: border-box;">' +
    '            <div style="word-break:break-all;width: 100%;float: left;text-align:center;">' +
    '                库存数量' +
    '            </div>' +
    '            <div style="display: table-cell;vertical-align: middle;width: 100%;float: left;text-align:center;border-top: 1px solid #000;">' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;border-right: 1px solid #000">整存数量</div>' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;">拆零数量</div>' +
    '            </div>' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;width: 15%;border-right: 1px solid #000;box-sizing: border-box;">' +
    '            <div style="word-break:break-all;width: 100%;float: left;text-align:center;">' +
    '                销售数量' +
    '            </div>' +
    '            <div style="display: table-cell;vertical-align: middle;width: 100%;float: left;text-align:center;border-top: 1px solid #000;">' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;border-right: 1px solid #000">整存数量</div>' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;">拆零数量</div>' +
    '            </div>' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;width: 15%;border-right: 1px solid #000;box-sizing: border-box;">' +
    '            <div style="word-break:break-all;width: 100%;float: left;text-align:center;">' +
    '                药品成本' +
    '            </div>' +
    '            <div style="display: table-cell;vertical-align: middle;width: 100%;float: left;text-align:center;border-top: 1px solid #000;">' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;border-right: 1px solid #000">整存成本</div>' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;">拆零成本</div>' +
    '            </div>' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;width: 15%;border-right: 1px solid #000;box-sizing: border-box;">' +
    '            <div style="word-break:break-all;width: 100%;float: left;text-align:center;">' +
    '                销售额' +
    '            </div>' +
    '            <div style="display: table-cell;vertical-align: middle;width: 100%;float: left;text-align:center;border-top: 1px solid #000;">' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;border-right: 1px solid #000">整存销售额</div>' +
    '                <div style="word-break:break-all;width:49.5%;float: left;text-align:center;">拆零销售额</div>' +
    '            </div>' +
    '        </div>' +
    '        <div style="display: table-cell;vertical-align: middle;word-break:break-all;width: 8%;text-align:center;box-sizing: border-box">' +
    '            利润' +
    '        </div>' +
    '    </div>' +
    sjDatas +
    '      <div style="font-size: 8px;display:table;width:100%;clear: left;border-right: 1px solid #000;border-left: 1px solid #000;border-bottom: 1px solid #000">' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width: 32%;display: table-cell;vertical-align: middle;text-align:right;box-sizing: border-box;border-right: 1px solid #000">' +
    '                合计：' +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width: 7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    (totalData?.invWholeCountSum ? totalData?.invWholeCountSum : '') +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width: 7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '                ' +
    (totalData?.invSplitCountSum ? totalData?.invSplitCountSum : '') +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width: 7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    (totalData?.salesTotalQuantityCount
      ? totalData?.salesTotalQuantityCount
      : '') +
    '            </div>' +
    '             <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '                ' +
    (totalData?.salesSplitQuantityCount
      ? totalData?.salesSplitQuantityCount
      : '') +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    (!CKLRSJData ? '***' : (totalData?.costTotalQuantity ? totalData?.costTotalQuantity : '')) +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '                ' +
    (!CKLRSJData ? '***' : (totalData?.costSplitQuantity ? totalData?.costSplitQuantity : '')) +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    (totalData?.salesTotalQuantity ? totalData?.salesTotalQuantity : '') +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:7.5%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box;border-right: 1px solid #000">' +
    '                ' +
    (totalData?.salesSplitQuantity ? totalData?.salesSplitQuantity : '') +
    '            </div>' +
    '            <div style="padding-left:2px;padding-right:2px;word-break:break-all;width:8%;display: table-cell;vertical-align: middle;text-align:center;box-sizing: border-box">' +
    '                ' +
    (!CKLRSJData ? '***' : (totalData?.totalprofit ? totalData?.totalprofit : '')) +
    '            </div>' +
    '        </div>' +
    '    <div>' +
    '    </div>' +
    '    <div style="font-size:8px;display:flex;padding-top: 10px">' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">单位负责人:<span style="padding-left: 10px;"></span></div>' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">采购人:<span style="padding-left: 10px;"></span></div>' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">仓管员:<span style="padding-left: 10px;"></span></div>' +
    '        <div style="word-break:break-all;width:25%;float: left;text-align: left;">财务:</div>' +
    '    </div>' +
    '    <div style="font-size:8px;display:flex;padding-top: 10px">' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">审核:<span style="padding-left: 10px;"></span></div>' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">验收人:<span style="padding-left: 10px;"></span></div>' +
    '        <div style="word-break:break-all;width: 25%;padding-left:10px;float: left;">制单人:<span style="padding-left: 10px;">' +
    userName +
    '</span></div>' +
    '        <div style="word-break:break-all;width:25%;float: left;text-align: left;">制单日期:<span style="padding-left: 10px;">' +
    moment().format(DateTimeFormatSimpleOnlyOne) +
    '</span></div>' +
    '    </div>' +
    '</div>'

  return content
}
